export default __webpack_public_path__ + "static/media/E.868e4f00.svg";